import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import brainImg from '@/assets/brain.jpg'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide2TwoSpeeds.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide2TwoSpeeds(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="flex flex-col items-center text-center px-4 mx-auto max-w-3xl">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1, ease }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] text-slate-400 font-semibold"
      >
        {c.eyebrow}
      </motion.p>

      <motion.img
        src={brainImg}
        alt=""
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 0.35, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.15, ease }}
        className="mt-6 h-28 sm:h-36 w-auto select-none"
      />

      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.25, ease }}
        className="mt-4 text-5xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.title}
      </motion.h2>

      {/* Side-by-side fast / slow */}
      <div className="mt-10 w-full max-w-2xl grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-14 text-start">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.55, ease }}
        >
          <p className="inline-flex items-center gap-3 text-2xl sm:text-3xl font-semibold text-white tracking-tight bg-red-500 rounded-xl px-5 py-2">
            {c.fastLabel}
          </p>
          <ul className="mt-3 space-y-1.5 text-lg sm:text-xl text-slate-500 leading-relaxed list-disc ps-5 marker:text-red-500">
            <li>{c.fastBullet1}</li>
            <li>{c.fastBullet2}</li>
            <li>{c.fastBullet3}</li>
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.75, ease }}
        >
          <p className="inline-flex items-center gap-3 text-2xl sm:text-3xl font-semibold text-white tracking-tight bg-blue-500 rounded-xl px-5 py-2">
            {c.slowLabel}
          </p>
          <ul className="mt-3 space-y-1.5 text-lg sm:text-xl text-slate-500 leading-relaxed list-disc ps-5 marker:text-blue-500">
            <li>{c.slowBullet1}</li>
            <li>{c.slowBullet2}</li>
            <li>{c.slowBullet3}</li>
          </ul>
        </motion.div>
      </div>


    </div>
  )
}
